module.exports = __webpack_public_path__ + "img/pr-1.1d74d324.png";